import Home from "./componants/Home"

function App() {
  return (
    <Home />
  );
}

export default App;